/**
 * Accepts any transition value then any number of CSS properties that you would
 * like to apply the same transition value.
 *
 * @param value Transition value to apply to all properties
 * @param properties Any amount of properties to apply the transition value.
 */
const transition = function (value) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }
  return properties.map(property => `${property} ${value}`).join(", ");
};

export { transition as default };
